import React, { useState } from 'react';
// import {
//   Radio, RadioGroup, FormControlLabel, FormControl, FormLabel,
// } from '@material-ui/core';
import { formValidation } from '../Utils/index';
import CommonModal from './CommonModal';
import CommonTextField from './CommonTextField';
import CommonPasswordField from './CommonPasswordField';
import { userTypes } from '../Utils/constants';

const DashUserCreation = ({
  setModal,
  createUser,
  title,
  userType,
}) => {
  const [state, setState] = useState({
    full_name: '',
    username: '',
    email: '',
    mobile: '',
    password: 'Pass@123',
  });
  // const [userRole, setUserRole] = useState(userTypes.manager)
  const [userRole] = useState(userTypes.manager);
  const [validation, formValidate] = useState(null);

  const handleChange = (val, field) => {
    setState((prevState) => ({
      ...prevState,
      [field]: val,
    }));
  };

  const submitForm = async () => {
    const validateState = { ...state };
    if (!validateState.mobile) delete validateState.mobile;
    const valid = await formValidation(validateState, userType);
    if (valid === undefined) {
      formValidate(null);
      validateState.userType = userRole;
      createUser(validateState);
    } else {
      formValidate(valid);
    }
  };
  return (
    <CommonModal
      title={title}
      width="xl"
      open
      onYes={submitForm}
      onClose={() => setModal(false)}
      successButtonText="Create User"
      cancelButtonText="Cancel"
      disableEscapeKeyDown
      disableBackdropClick
    >
      <div className="row">
        <div className="col-6">
          <CommonTextField
            error={validation && validation.full_name}
            handleChange={handleChange}
            name="full_name"
            label="Full Name"
            placeholder="Full Name"
            helperText={
              validation
              && validation.full_name
              && validation.full_name.length > 0
                ? validation.full_name[0]
                : ''
            }
            required
          />
        </div>
        <div className="col-6">
          <CommonTextField
            error={validation && validation.username}
            handleChange={handleChange}
            name="username"
            label="Username"
            placeholder="username"
            helperText={
              validation
              && validation.username
              && validation.username.length > 0
                ? validation.username[0]
                : ''
            }
            required
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <CommonTextField
            error={validation && validation.email}
            handleChange={handleChange}
            name="email"
            label="Email"
            placeholder="Email"
            type="email"
            helperText={
              validation && validation.email && validation.email.length > 0
                ? validation.email[0]
                : ''
            }
            required
          />
        </div>
        <div className="col-6">
          <CommonTextField
            error={validation && validation.mobile}
            handleChange={handleChange}
            name="mobile"
            label="Mobile No."
            placeholder="Mobile No."
            type="tel"
            helperText={
              validation && validation.mobile && validation.mobile.length > 0
                ? validation.mobile[0]
                : ''
            }
          />
        </div>
      </div>
      <br />
      {userType === 'supplier'
        ? (
          <div className="row">
            <div className="col-6">
              <CommonPasswordField
                validation={
                  validation && validation.password ? validation.password : null
                }
                handleChange={handleChange}
                userType={userType}
              />
            </div>
            {/* {userType === 'manager' ? (
          <div className="col-6">
            <FormControl component="fieldset">
              <FormLabel component="legend">Select Role</FormLabel>
              <RadioGroup
                name="userRole"
                value={userRole}
                onChange={(e) => setUserRole(e.target.value)}
                style={{
                  display: 'block',
                }}
              >
                <FormControlLabel value={userTypes.manager} control={<Radio />} label="Manager" />
              </RadioGroup>
            </FormControl>
          </div>
        )
          : null } */}
          </div>
        )
        : null}
    </CommonModal>
  );
};

export default DashUserCreation;
